var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRichmondImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 542 147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24{fill:none;stroke-miterlimit:10;}.cls-1,.cls-3{stroke:#2e6ead;}.cls-1,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24{stroke-width:3px;}.cls-2{filter:url(#drop-shadow-25);stroke-width:18px;}.cls-2,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24{stroke:#000;}.cls-3{stroke-width:2.5px;}.cls-4{filter:url(#drop-shadow-11);}.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15{stroke:#a01816;stroke-width:5px;}.cls-5{filter:url(#drop-shadow-12);}.cls-6{filter:url(#drop-shadow-10);}.cls-7{filter:url(#drop-shadow-3);}.cls-8{filter:url(#drop-shadow-1);}.cls-9{filter:url(#drop-shadow-9);}.cls-10{filter:url(#drop-shadow-7);}.cls-11{filter:url(#drop-shadow-6);}.cls-12{filter:url(#drop-shadow-5);}.cls-13{filter:url(#drop-shadow-2);}.cls-14{filter:url(#drop-shadow-8);}.cls-15{filter:url(#drop-shadow-4);}.cls-16{filter:url(#drop-shadow-13);}.cls-17{filter:url(#drop-shadow-16);}.cls-18{filter:url(#drop-shadow-15);}.cls-19{filter:url(#drop-shadow-18);}.cls-20{filter:url(#drop-shadow-14);}.cls-21{filter:url(#drop-shadow-17);}.cls-22{filter:url(#drop-shadow-19);}.cls-23{filter:url(#drop-shadow-20);}.cls-24{filter:url(#drop-shadow-21);}.cls-25{filter:url(#drop-shadow-24);}.cls-25,.cls-26{fill:#2e6ead;}.cls-26{filter:url(#drop-shadow-23);}.cls-27{fill:#a01616;filter:url(#drop-shadow-22);}.cls-28{isolation:isolate;}.cls-29{mix-blend-mode:multiply;opacity:.75;}"), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9e0000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9e0000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9e0000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9e0000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9e0000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-5",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-6",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9e0000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-6",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-7",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-7",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9e0000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-7",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-8",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-8",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9e0000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-8",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-9",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-9",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9e0000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-9",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-10",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-10",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9e0000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-10",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-11",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-11",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9e0000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-11",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-12",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-12",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9e0000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-12",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-13",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-13",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-13",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-14",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-14",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-14",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-15",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-15",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-15",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-16",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-16",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-16",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-17",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-17",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-17",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-18",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-18",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-18",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-19",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-19",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-19",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-20",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-20",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-20",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-21",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-21",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-21",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-22",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-22",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a01816",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-22",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-23",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-23",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2e6ead",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-23",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-24",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-24",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2e6ead",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-24",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-25",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-25",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-25",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M173.86,77.78v-28.88c0-15.06,14.54-22.58,27.04-13.83"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 210.37,
    y1: 77.78,
    x2: 210.37,
    y2: 36.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 210.37,
    y1: 33.38,
    x2: 210.37,
    y2: 28.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M259.44,70.11c-12.85,13.95-39.53,6.82-39.53-15.21,.35-24.07,30.14-30.14,40.56-14.82"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 272.79,
    y1: 77.92,
    x2: 272.79,
    y2: 8.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M307.17,77.92v-29.22c.78-21.46-34.38-22.45-34.38,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M380.72,77.92v-29.22c.7-20.64-31.33-22.81-31.24,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M317.45,77.92v-29.22c-.72-20.64,32.14-22.81,31.96,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 349.44,
    y1: 77.92,
    x2: 349.44,
    y2: 48.7
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 411.7,
    cy: 54.62,
    r: 22.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M442.32,77.92l.04-27.67c0-23.91,34.26-23.91,34.26,0v27.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M529.91,8.18V53.5c-.4,13.88-7.84,22.8-21.67,23.42-13.13,0-22.94-10.22-22.94-22.3,0-12.98,8.82-22.3,22.31-22.3,11.79,0,22.31,9.6,22.24,21.07"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 182.91,
    cy: 117.04,
    r: 14.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M220.11,88.22c-10.03-1.5-16.24,5.65-16.24,13.13v30.25"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 213.33,
    y1: 103.54,
    x2: 203.87,
    y2: 103.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M238.44,88.22c-10.03-1.5-16.24,5.65-16.24,13.13v30.25"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 231.66,
    y1: 103.54,
    x2: 222.2,
    y2: 103.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 238.44,
    y1: 131.6,
    x2: 238.44,
    y2: 105.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 238.44,
    y1: 100.71,
    x2: 238.44,
    y2: 103.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M270.11,107.71c-9.11-9.46-23.65-4.16-24.42,9.34-.42,12.62,15.18,19.04,24.42,9.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M301.73,125.07c-7.28,8.15-17.08,8.38-23.65,0-2.75-4.94-2.7-11.18,0-16.02,5.93-7.84,18.07-8.4,23.65,0,1.59,2.21,2.45,4.63,2.61,7.27h-27.46"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    className: "cls-29",
    width: 16,
    height: 39,
    transform: "translate(319 102)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAnCAYAAAAGjMh0AAAACXBIWXMAAAsSAAALEgHS3X78AAABYklEQVRIie2WW07DMBBFT9OQ8ihUqoQQm2Az3QeL6T7YTHcCVE0TEoeP3oGJ66SVkPjqSJE1Y8/xtR15DCP28vo2GesHOBrgknxfB7BZr7pBgEvMFM/cuCBIiEF5BMyAqeK5QB3Q6DNYX4Fmz5RUADfATLAWqIASqAUKpiJ3IAPcAg/APXAFfAGfGhPccjqALFp7IcASeAKe1S4VL2xvLG9IwQJ41FJKLWOrzzZ5cAkzYC7InWbdKp47AB5gZqdQANdS0Mqf0j/anwSziVPijzJ3yTYmCUiBfJv8rVOAGDZqpwAn7QK4AC6AfwIcVaJzAHZlh6hNwjzAJ7b8VqNGfhIUX6qWXAN7DnfhXr5BemYAm7nhUMa2wLsSS/mV+k3JIGCn5CmHWlDJ36UAVlx9PZiTro0fUlID7Wa9CmMKOrcHvjqnFUhFqqjE74MWV9q9ArPg2iaKdyRO4c9vpFE755X2DQxsibkL05wKAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 324.51,
    y1: 132.02,
    x2: 324.51,
    y2: 106.36
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    className: "cls-29",
    width: 16,
    height: 15,
    transform: "translate(319 97)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAACXBIWXMAAAsSAAALEgHS3X78AAAA2UlEQVQokY2T3Q3CMAyEP9KWIiHEJizDHgzDHizDLkj9Dw/Y0tW0hbxEjnPnsy+BjXW5PXZbeYCvCwLSXAZ43q95lUCAyc6T3JuMZIpEZSBMQGHnhcUTMAKDkM0VWHUH74EDUFs8Ai3QAJ3Fk6soA1lp4BNwBCqgB15SfaagFLArqA18NjWd3elMibeVAVKwykkqA9e2VzITpG1SsMYH1kvFzuJR5ccZZAG30rPOoBWSRRszH6sa6Tm6MCjYh6c9/XoHMwujAp+B76svcVFBUBJzq39hc/3zG9/4u12KbyjhQgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 324.51,
    y1: 101.39,
    x2: 324.51,
    y2: 103.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    className: "cls-29",
    width: 16,
    height: 38,
    transform: "translate(432 102)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAmCAYAAADN0BvRAAAACXBIWXMAAAsSAAALEgHS3X78AAABYklEQVRIie2WW07DMBBFT9LQQikPIcEy2Ez3wWKyDzaTZfCBKI2atiQxH70mk8RJKvHbkSJrPJ7jazvyGCbs9e09GosHgybJxh1Alq7dIMAkxorFJlwLUltQEhAQAzPFEoEcUOrzsLYCzR4raQ7cAAvBKuAAFMBRoDpL184qsIAlcA/cAVfAD7DVmNosx0Vm9kiDl8Aj8AI8ScUB+AQ+gC9gJ+ioggfgWUsptIxcn9/kQcACWAlyqz3J1Z8YwOgpzIFrKajkz2gfbdsR1SuxR5mYZD8mCAiBbNv7c4cAXdignQMYtQvgArgAzge4seAQwNEUEdv2YF2ATaxoikkpvwcK3Yk++QjsOV1le/ke8mcW4GcuOdWBHNgosZB/UNwrGQTslDyjKSwb9bcAtjba63xFuLR9S8kRqLJ0XY8pcGYPbHENK5CKUE3olvcKVebuHnirTVt2+h2dU/j3E2fSph5Zv3Cwjt2GlMNNAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 438.5,
    y1: 131.9,
    x2: 438.5,
    y2: 106.24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    className: "cls-29",
    width: 16,
    height: 15,
    transform: "translate(432 97)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAACXBIWXMAAAsSAAALEgHS3X78AAAA50lEQVQokYWTWw6CQAxFD/gAY4wm7sPNsA8Xwz7cjPsw0Q+joDD+3JI6DjI/pLnc9rSdgYlzOJ6yf3pSdCavB4BzXYXRBM6YS8ud3CtJ7xPNEwA5MJM2U9wDHfB2yb4JVN3MS6AECsUd0ABPoFXcn+sqxASZKpfABlgDC+AF3F31gWAemY2gkHkrmlb/tCKxtkLm8K36SsY9sFOyBrgCF+AGPDSPkMPPamxgL1exVdx5/HgGwZkb17OfQeOSJNcYhPZ0PcdbeJvZBjecaJVj92BYYYrAZmDf0ZuYJIhIYj35FibP1Gv8ALwfYxiLCIg7AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 438.5,
    y1: 101.37,
    x2: 438.5,
    y2: 103.81
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    className: "cls-29",
    width: 45,
    height: 44,
    transform: "translate(374 97)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M406.09,125.07c-7.28,8.15-17.08,8.38-23.65,0-2.75-4.94-2.7-11.18,0-16.02,5.93-7.84,18.07-8.4,23.65,0,1.59,2.21,2.45,4.63,2.61,7.27h-27.46"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    className: "cls-29",
    width: 45,
    height: 45,
    transform: "translate(440 97)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 460.47,
    cy: 117.78,
    r: 14.56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    className: "cls-29",
    width: 38,
    height: 42,
    transform: "translate(326 98)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAqCAYAAADf/ynVAAAACXBIWXMAAAsSAAALEgHS3X78AAADkklEQVRYhe2ZWVLbQBCGP2Mb7JjNgYQkle0EXIZ7cBjuwWU4Qx5CEsAGjI035UF/e1qDJVsiSVWqmKqpsaSZ1qfeZnGNZ5Tj0/Na0fOLs5OkquxCwStgam58LCdxbQLlIdcGE5DVDdfa7xhsrpq4NlkXcCXYEqA60ACaausRnIHMgCkwUTsrA1gI5qDqqk1gC2i5uungzHRTYAw8AkO1j4KcqRbC5YIJyjTUFEQb2AZ2VDu633SyTFMjYADcAfeqQ903wHke3FIwB9WQRl4Bu8Ae0FXdE+SW+kEw45RUQwPgFugBN0BfoA96Ps2DewLmzNfQS7cFcgi8UbsvjbVINVoj6+yJNGJwfeAK+KXakwZHeXAbSxRmPtWUprrAO+AT8EXtkTS2pf4TUjOZP801fhd4qzFfgc/AB+CAoO06UItzYsNfRM7ekuBD4D3wUQLb6j4WyMABzdzYjl5uQdIma3aL3Jn7vRyMkBKaErRPar4jQXUk4J7UHD1SMw0cWIPgkwfAa2m3o2c19bOoHes6OT49X5h0ARZpK/atrkBnAvmheqXrB70g0fi2wAa6jwDbgjXfu3djp0Uas0hskTr3vmpHz+8F9A24BK51zyLMZGxGWrRg6hL8tk+IVIOz4Mk4vzejge2pbWpgT2CXkcbsyweE3HUD/AS+q16pT42QDy0PNvTuRRA04Mm0Yxrzzgupg/f0gmvS/PTkSwk+NNe1ucaO5NlMYQHhZ45FidOFZfpNDbRwnhLykWloSHDc+cXZyfzi7MRy2Yw0hYzUt6+PuiM1r/liw2sLl1djU8bTkPnghGCqTNYmmvP02xLsRH0fCOYeEfzOA2XyWKwxD2eDLLRHhHxlq4WlE7G7NyebGvxE7k3/ZAbKy/zxEsZWCxbWJrho6WLPzbxTssufwrIMLC4+Qy+WLCugYkA/h/paGWyZsDJQebJWlnU0Vlronyjrgv3z8gJWtryAlS0vYGXLfw32N5LqSpl5YH4Cjue658CsLTMG84Ntqx+vCsoCVpIZb0Ygu4YakS4aR7jVagmoyjI9WHzuYEti29j63ZBf4xeVyjLzwB4kwDYSj4RtVlWwUjIXS9rj03O/Edkm3bDa1m1CupG41VeOgZk2H7nlOTKLNJYQ/MFObobLvq6gVJaZ2QREh3W2taoRTgkXkbTuWWpVmXlRae00up9QPSpLySw6UYyfVzoW/2syV/3JUKWsI/M3viT+a/9DknYAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.44,131.9l.02-17.23c0-14.89,21.33-14.89,21.33,0v17.23"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    className: "cls-29",
    width: 32,
    height: 43,
    transform: "translate(409 97)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAArCAYAAAAZvYo3AAAACXBIWXMAAAsSAAALEgHS3X78AAAC4klEQVRYhe2YfVITQRDFf/mCEBE1qAh6Bi7DPTgM9+Ay3AFU1FCBBPO9/jGvd3uHXbLCUpZV6aqpSVLZeW9e9/R0L/xjazz1wePT80rPXpydJLURcKAN92zZGombkzIylQg44KaeabrhyXjwBFi5Yd9zRNYSELiBtt3oAK0CEh58oTHXvDQyRqJdAbwpoA6wDexodIGtiIQRMPApMAHugd/6bkQeV8CBtwXcA14Dexq7ItHR/8yMwEygt8ANMATuRGgBrC7OTpJCBRy47XoXeAfsA++BviPQ0kZ8gCUiMAYGWgcyl1hcPHRBBN7VrvvAAfAJ+CgyOwKHzLeQqbqUak2C9GNgJFXmRjrngkj2LkHqfeAQ+Ky5L/CGFpqS+TYRKSM2Jch/BVwCX/X93v6fKuCivUUIrl2BHQJfgCOR6Wq3Y4J/77Tg3BGwE7LUrseOpClFUQzY7neAN8AHAR8RfL+tRYbAL+CnPo8KCJjfJ47oFHcUIR8D3vc94C3B3wdSYlsgA+A78A34IQKppOTzRUO/Twi+N/+nAduO5DcCpkBfc1cL3RD8eCkCA+3eduY3YrkhoSAZlSUiH4A94JV2vpKE14SAupL8t2Tn2jJgIxpFaTm12AX+FGxJjYZ2OJTk1wT/DyWpBVZ80fgTll5M8YUUK+BJWIJZisCtQC3oJgRZc7ndLL6uy67lokwYXyxLQlbzOX1Glk5XBWusrQPMmuv/kl4sc/KBlN7zz7F1BBIeBpH/7dlWRYGkYNRmVQi8qG0IbAhsCGwI/BcEak29VQn4C8jPtZOJCXjgJVknk2ss6yRSVJAYuBUhLc0z8h1Q7QTirnZEKL+sybTqt6wGrJXAvcBbhKrYilKr/2sjkBaOx6fnVohaW7ZHaEw7hFLsjlCYjpA7yurBv7HHFEjIYsAq48fK8CdZWXfcIt9eWXfzoLN5rpWdApsX0e8JNZ+Cwlc00es4s9JXbS9qVV9IPtX+ALNEU84O/HPYAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M415.05,131.82v-19.52c0-5.18,9.12-12.75,16.95-7.26"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    className: "cls-29",
    width: 32,
    height: 44,
    transform: "translate(476 97)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAsCAYAAAAEuLqPAAAACXBIWXMAAAsSAAALEgHS3X78AAAC2klEQVRYhe2YbVIaQRCGHz7kw2BMtIwmuYOX4R4exnt4Ge6QqhiDEREIssvmx7692zsgYNyt5AdT1TUM7M77THfPF/CPS+0tL19e3Wx8f3DdT0oFCARr7v2wn8TVySaYnQCcsInWnXkQD7B0Zu0VkK0AEjfRhqwps7aBePEYWACR6thgPMRGAImbcBNoAW1ZR+2Wg0AiEfAM/AamqucOJINo7iBuwl2g5+ydvmvrmRBgBoyBB2Ckz5YT8UYPOPEDCfSAY+AE+KjPPQGEHkAAU4nfAT+AnwKZ6ffl4LqfrHggEO8ARxI+A86BUwF0g5FDnphLUpd3NciFhGekock8UAAI3N6W+ClwAXwRwIegY0u0xIE3VHeBQw3Evi94PQNw2d4gd/uJxL8Cn9Vua4QW4wlpksXu3bY+z2UR+XQslDAENoJDjfSThC9IY9+SC8fAL2AIPJLG2wNYbsTAE3nss1lQAFjj+p5cf+7c3lQnPrGGgpmp47qEbYoiDzzJnkNPeA/U1O4C7wVwJvGWOroHvsvuBDN1HVsfB6prFNcES8CVdcB7oCMAm24ddfIg4W/ArUIwEZitcn6ZtoSzVTFyz2WlGSy1NvVssenouYncfSsbyqWWYNmmQ743mCXOVvYDHwKjthh21F6QxvlewiPyzI/CToONy8qLO6IPgQ+DxTARwEQQY9KYZ24PO3XtrWcBG7WVcKs19y0kOKO4oayI/02pB20fO8g3jsiZzeM3i68DCItPniXFhCqlbAPwEKUKvwag0rIH2APsAfYA/z1A6UvvLgB+A/J1JTAewAuv24IrAQnvBSZup9gGxdPskpKLAdjII/Jz/EjCM4oH0LU3nDIBphK3W85c7WkVADWAy6sbfyLukd4LjkgPp3YqfiS/3cSD634p4XjJAwl5DsTkh9JqPABr/46xq1VCMBvKOA1bWTcLrI6C7xMqmAUrf9G89mZTadn2T2gZ5Q+bXE7Ql5dAqQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M481.57,132.13v-19.52c0-5.18,9.12-12.75,16.95-7.26"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    className: "cls-29",
    width: 16,
    height: 51,
    transform: "translate(360 90)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAzCAYAAACey4j5AAAACXBIWXMAAAsSAAALEgHS3X78AAABZ0lEQVRIie2XW07DMBBFT9OQ8ihUqoQQm2Az3QeL6T7YTHcCRE1bEoeP3IGp66SVkPjKSJE1tuf42s7HNQzEy+vbZGgc4GSCK/JjLcBmvWp7Aa4wU3/m5gVBQgzKI2AGTNWfC9QCtT6DHSvQ6pmKCuAGmAnWAHugAg4CBVORO5ABboEH4B64Ar6AT80JbjstQBbtvRBgCTwBz2qX6i/sbKyuT8ECeNRWKm2j1GeH3LuFGTAX5E6rlurPHQAPsLBbKIBrKWiUTzm+2p8Ci4lT4q8yd8U2JwlIgXyb/K1TgBg2GOcAZ2MEjIARMAJGwAj4V8CJK7sEYPYlRG0S5gG+sOHXmdXKk6DYYFjxAdjR+YKdcoMchQFs5ZrO0pXAuwor5XuNm5JewFbFUzpftFe+TQHMaHpvNCftEz+k5AA0m/UqDClo3Rl4p5pWIBUpgxV75QZnc70Ci+DaOupvSdzCn98Lg3HJi+Uby9mJ0RmvCsoAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 365.85,
    y1: 94.11,
    x2: 365.85,
    y2: 132.22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    className: "cls-29",
    width: 31,
    height: 16,
    transform: "translate(353 97)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAQCAYAAADu+KTsAAAACXBIWXMAAAsSAAALEgHS3X78AAABRklEQVQ4jc2VbU7DMAyGn3QVbCA+JjQBl+AyuweH2T24zC4B/AJUtu6ja/gxO/NKwqg2PixZTeM6r1/bcR0Jubt/cClbWxmPhj62/wlAQJ2x7xOEFwXwzSDCwYZpFtFooDtAAeqIhkzkDadM9nLgyKzbBGCBK9GFWdf6oYPAOgM6wDFwYlSDyFqAK/ACmBqdAyugHo+G3jJ3AtIDzoE+cAmcSgAddveA1nglwBPgFXgx+4G5givzXJifAVfAALgAumL7LngFzIA3CVrfZ2xS753pbmXdB66BW+BG2PfYrv1XoikvhfUT8Ag8SwZKsfus0f6amiXr+kxZp+5dtDDrmFr7hE2dl3JuwLI1t00yl0NycSjYv+aFnBtSDttXTWtVCkAlzofq9pBu/bA5ZH7lnqeGjDro80cmnMr/mO2JIA4iqb/an8oH6NKqhQIDSTUAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 357.52,
    y1: 102.96,
    x2: 375.5,
    y2: 102.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    className: "cls-29",
    width: 45,
    height: 45,
    transform: "translate(497 97)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAACXBIWXMAAAsSAAALEgHS3X78AAAGAUlEQVRYhdWZWXJbNxBFDylSJCXZlmx5ipNUVuDNaB9ejPbhzeg3+UlVYluKNVhTLI75wL1EP/BxtP0RVKE4PeIdXHQ3uvHgB7W37943ftTY32XgABjHawCT8Hn6/uT4KH6/dtsYugCNvVmMO1nQN5rA2tCCjYDuW6EbfAKMgZFex8Vn/74W/MrQNbBbQAtoh76t15auMeAAGIbX8v0YmKwKvhJ0ALaSbaADdNV76l19vy3oCdAv+lf1f9UfNIERMF4FfCm0gK1sO0DuAY/U94Ad9W6AHguoL7gHgd4A1+o3wL1+G64CvhA6ALdICu4I8glwAOzr/a5+s8o2jwlJwWgShr4APgPnwCVwS1Z9Ifhc6ABsU9gT6DPgUK9P9H0ngNqUyvvESdwL9Az4BJxqEjck01kIXgtdKNwlqfsMeAm8Ap6TVO6SzGZM1blGYfxoVh29nwj8QtB/Ax9Jyht8rqnMQAeni8CHwGvgjaAPSGYwJi33LXBHts2BwBoB2D7wmGRKTf33XNB/AR8C+IMmPxNVWjVCR3V2BPhSwG+Ap1Ksr8HPpdiVwL28JfQj0urYtB5pnH1d/0COLH1CKCwBK9BFaItm8Ur9qb7vC/KUtLyfgS9B6VGAbpFWZZfkAzdS+LlUb0qcx7rfribvaDLTSqWj8/WkwnP1g6DwBckGP5CdKN7ICkXfsAk5Nn8lqd4LcOWO6l5vHoXKjhb7Undfalnhj2TnOadwnuImBn9gdpO5lboNvb9HkaMErYVWKyOG43BXA92QlP1A9vbrAGyzKFuDat4x1CRuSebQ0ucb0mr0w1gLbTqahr3dcXhLYBeCPqMaV63woubd0UnSkGQqHY0/EnjpFzOtBRXTiErvSYWOrr0nmcYl2ekM4UkvSwtsnwYeUN09Y6yvVRldHAeMO6BziW1y4vMvWVmoT54W9XKbh+o279Wq5OhlFVRnHs4zfKN2gPTvPU2kw3KzmNfiysTce0h21qj6DHRpHtsCcm+RTOUxKW63WWJ3a4C7OS95IDmjd1iA4dt376db+jylI3TXf1Tf1mB9Nlc53jPG4oFgL0mhFHLUmdp4Xchz7lxWKXv6szeYmWXbADhWQGjcL6RdFnIOPgBGb9+9b5wcH01ahZHbrgYkh7sjJ/UjcmRpl7NfAzQCRydukYS40JhWPKa8SemT46OJwG1TfVLQPxfsVw3c0O+xSN20GdjO7GiFxr0ki+NVnzYvixVz/LzSxQMN0CHHUk+uchSwRnMS1SE5NqRo5HQ15h6RbQbaMzR0Q+/vyXWfZ2y1HVcX5gk1wE1y1ncoBteYW+S8ZFp6leNPZS+qlW2B7mjwHtlEnDc4AZqb99YAW+UeKUV4DfwG/EoKpRNSivAH8DvwJym/uQOGJ8dHY5iNHl76AdnuxmQHtBJOjqJ3L3LMmEHGSj1GKjv/Jck8r8lbfWXc6TauwO3oEfNh294hqYJ5QbXyiHmDd7IHqqsRQ2TM13clRkPAV+RKaG4yFnOP8mgq1omG/gn4BfiZtLTP9FuPak5RnkbZ5Hqa7AE5T+8JyhHrH0H7SGGmTqyrEd18kZXZ1c280TgBcr8lL2cst5xU+YDngFQJvdCEt8gR61TQVywoCOqgo5l4yW23TbJj+qRpV+pdFeDzClufnVjlAcl+XW/GSmjlahxyheHq4kqqOL/ukatyF6WX5CMu5yUObz6Z2te1e5rMgLRtn5EqoVONY5VrE7J50HYsl0CfyTbbEPBOuLkrbReuXtbS6TzpppS8DsCfWGLLbpueML0I4C1yhlbmwHZmHwW3yAc8tmEr/G3HYgX4srM8qxdzhBiimuE777hfSKt3RjVaLAVeCF2A152auruWLBMcJ2ExEfOxgWtN15srn5guhS7AYz1oG90Jr47V7RroeOx1Rz4qcLSZpgPf5VA9gEfVvVnECsefnaW5ORLFQ5oyd1n5KcDK0AEcZh8OeRLlkZZbfFgUK++Ym6/8vGUt6Br4+Pityez2HaHLvKaSXK37WG5t6Bp4jxMnU7ZJeP3mh6AbQ5dtlcfK3/qk9n/d/gP3g8xFAGs/LQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M529.37,109.45c-5.51-8.47-17.41-8.89-23.72,0-1.9,2.58-2.57,5.58-2.76,9.2h28.79c-4.71,17.6-20.99,14.8-26.26,6.61"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M49.67,135.89C1.06,103.47,19.98,18.9,79.67,19.94V5.55c-18.39,0-34.91,5.58-46.07,16.75-1.17,1.33-1.95,1.32-1.78-.86-.02-3.3-.89-5-2.02-6.37-.27-.29-.63-.35-.97-.04-4.23,3.75-9,6.74-14.53,9.33-.44,.14-.59,.69-.36,.99,4.13,7.26,2.84,10.94-.39,17.09-11.87,25.24-12.54,50.96,0,77.27,2.56,4.7,6.02,10.07,10.49,16.2h25.62Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 92.69,
    cy: 12.81,
    r: 8.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M103.41,8.28c1.43,6.55-.28,12.12-5.92,14.67,17.17,6.77,27.13,19.54,32.49,32.58,13.1,30.81,1.55,63.34-21.8,80.24h25.25c28.57-32.07,20.53-82.02,1.12-104.98-6.25-7.67-11.29-13.65-31.14-22.51Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 78.69,
    cy: 81.98,
    rx: 42.05,
    ry: 47.91
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRichmondImg);
export default __webpack_public_path__ + "static/media/richmond-img.782dd27b336e42cad6ec28648899fc0d.svg";
export { ForwardRef as ReactComponent };